export const getSingleDocument = (payload?: any) => ({
    type: "@saga/GET_SINGLE_DOCUMENT",
    payload
});

